import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogDokumenAkuntabilitasProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPelaksanaanTugas: React.FC<
  TDialogDokumenAkuntabilitasProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="md"
    >
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Tentang Pelaksanaan Tugas" />

        <div className="p-6 space-y-8">
          <div className="space-y-6">
            <Text>
              Pelaksanaan Tugas mengacu pada dokumen yang secara sehari-hari
              memang dikerjakan dan dihasilkan oleh Pengawas Sekolah dalam
              melaksanakan Pengelolaan Kinerja.
            </Text>
            <Text>
              Pelaksanaan Tugas bukan tambahan dokumen baru. Pelaksanaan Tugas
              tidak menjadi penilaian dalam Pengelolaan Kinerja. Tidak perlu ada
              Bukti Dukung yang dikumpulkan di dalam sistem.
            </Text>
            <Text>
              Terdapat 2 Pelaksanaan Tugas yang harus dibuat lalu diperiksa Tim
              Kinerja dan Pejabat Penilai Kinerja pada tahap Pelaksanaan, sesuai
              dengan peran Pengawas Sekolah sebagai pendamping menurut Perdirjen
              GTK Nomor 4831 Tahun 2023, yaitu:
              <br />
              <br />
              <ul className="font-bold list-decimal list-inside">
                {[
                  'Dokumen Perencanaan Pendampingan Satuan Pendidikan Sesuai Binaan',
                  'Dokumen Pelaporan Pendampingan Satuan Pendidikan Sesuai Binaan',
                ].map((item, index) => (
                  <li key={index}>
                    <Text as="span" className="!font-bold">
                      {item}
                    </Text>
                  </li>
                ))}
              </ul>
            </Text>
          </div>
        </div>

        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
